<script lang="ts">
	// Listens for a window-level `sayano:open-sidebar` CustomEvent and opens
	// the mobile sidebar drawer via the Sidebar context. Must be mounted as a
	// descendant of <Sidebar.Provider>, since useSidebar() reads from context.
	import { useSidebar } from '$lib/components/ui/sidebar/index.js';

	const sidebar = useSidebar();

	$effect(() => {
		if (typeof window === 'undefined') return;
		const onOpen = () => sidebar.setOpenMobile(true);
		window.addEventListener('sayano:open-sidebar', onOpen);
		return () => window.removeEventListener('sayano:open-sidebar', onOpen);
	});
</script>
